import PageRotationControlsContainer from './PageRotationControlsContainer';

export default PageRotationControlsContainer;